import { render, staticRenderFns } from "./ESGPanelTemp.vue?vue&type=template&id=17d3524a"
import script from "./ESGPanelTemp.vue?vue&type=script&lang=js"
export * from "./ESGPanelTemp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports